import React from 'react';

function Header({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <div>
      <h1 className="text-2xl font-nunito font-[400] leading-10 text-gray-900 ">
        {children}
      </h1>
    </div>
  );
}

export default Header;
